.ux-iws-software-updates {
    display: block;
    position: relative;

    .ux-info-box & {
        margin-bottom: 20px;
    }

    .ux-iws-software-updates__modal-trigger {
        display: block;
    }

    .ux-checkbox {
        .ux-text-normal {
            line-height: 1.3;
        }
    }

    .ux-iws-software-updates-modal-dynamic {
        opacity: 0;
        transition: opacity 0.25s ease-in-out;

        &--show {
            opacity: 1;
        }
    }

    .ux-iws-software-update__modal-switch-item {
        display: flex;
        align-items: center;
    }
}
